import { useState, useEffect } from "react";
import { Modal, Image } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import Close from "../../images/close-icon.svg";
import ChangePasswordModal from "./ChangePasswordModal";
import EditProfileModal from "./EditProfileModal";
import { auth } from '../../Firebase';
import { signOut } from 'firebase/auth';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getFirestore, collection, query, where, getDocs, doc, getDoc } from "firebase/firestore";

const MyProfileModal = ({ showProfileModal, onClose, userId }) => {
  const navigate = useNavigate();
  const [showChangePass, setShowChangePass] = useState(false);
  const [showEditProfile, setShowEditProfile] = useState(false);
  const [shouldOpenEditProfile, setShouldOpenEditProfile] = useState(false);
  const [shouldOpenChangePass, setShouldOpenChangePass] = useState(false);
  const [profile, setProfile] = useState({
    name: "",
    phone: "",
    email: "",
    platform: "",
    createdAt: ""
  });

  const handleCloseChangePass = () => setShowChangePass(false);
  const handleCloseEditProfile = () => setShowEditProfile(false);

  const handleEditProfileClick = () => {
    setShouldOpenEditProfile(true);
    onClose();
  };

  const handleChangePassClick = () => {
    setShouldOpenChangePass(true);
    onClose();
  };

  const handleLogout = async () => {
    try {
      await signOut(auth);
      toast('Logged out successfully!', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      onClose();
      navigate("/", { replace: true });
    } catch (error) {
      console.error("Logout error:", error);
      toast.error("Failed to log out!", {
        position: "top-right",
        autoClose: 5000,
        theme: "light",
      });
    }
  };

  useEffect(() => {
    if (!showProfileModal) {
      if (shouldOpenEditProfile) {
        setShowEditProfile(true);
        setShouldOpenEditProfile(false);
      }
      if (shouldOpenChangePass) {
        setShowChangePass(true);
        setShouldOpenChangePass(false);
      }
    }
  }, [showProfileModal, shouldOpenEditProfile, shouldOpenChangePass]);

  useEffect(() => {
    const fetchUserDetails = async () => {
      const db = getFirestore();
      const uidToUse = userId || auth.currentUser?.uid;

      if (!uidToUse) {
        console.error("No userId or current user available");
        setProfile({
          name: "Unknown User",
          phone: "N/A",
          email: "N/A",
          platform: "N/A",
          createdAt: "N/A",
        });
        return;
      }

      try {
        const userDocRef = doc(db, "users", uidToUse);
        const userSnapshot = await getDoc(userDocRef);

        let userData = userSnapshot.exists() ? userSnapshot.data() : null;

        if (!userData) {
          const usersRef = collection(db, "users");
          const q = query(usersRef, where("userId", "==", uidToUse));
          const querySnapshot = await getDocs(q);
          if (!querySnapshot.empty) {
            userData = querySnapshot.docs[0].data();
          }
        }

        if (userData) {
          console.log(userData, "userData");
          setProfile({
            name: userData.name || "N/A",
            phone: userData.phone || "N/A",
            email: userData.email || auth.currentUser?.email || "N/A",
            platform: userData.platform || "N/A",
            createdAt: userData.registered_At
              ? new Date(userData.registered_At.seconds * 1000).toLocaleString()
              : userData.registered_At || "N/A",
          });
        } else {
          console.error(`No document found for userId: ${uidToUse}`);
          setProfile({
            name: "N/A",
            phone: "N/A",
            email: auth.currentUser?.email || "N/A",
            platform: "N/A",
            createdAt: "N/A",
          });
        }
      } catch (error) {
        console.error("Error fetching user document:", error);
        setProfile({
          name: "Unknown User",
          phone: "N/A",
          email: auth.currentUser?.email || "N/A",
          platform: "N/A",
          createdAt: "N/A",
        });
      }
    };

    if (showProfileModal) {
      fetchUserDetails();
    }
  }, [showProfileModal, userId]);

  return (
    <>
      <Modal
        show={showProfileModal}
        onHide={onClose}
        centered
        backdrop="static"
        keyboard={false}
        contentClassName="password-modal-content"
        dialogClassName="password-modal-dialog"
      >
        <Link
          onClick={onClose}
          className="modal-close-floating"
          aria-label="Close"
        >
          <Image src={Close} alt="Close" />
        </Link>

        <Modal.Body className="password-modal-body p-0">
          <div className="head-bg">
            <h5 className="password-modal-title">My Profile</h5>
          </div>
          <div className="inner-modal-content inner-radius">
            <div className="text-inner">
              <h5 className="fw-bold">{profile.name}</h5>
              <div className="info-details d-flex align-items-center gap-2">
                {profile.phone && <span>{profile.phone}</span>}
                {profile.phone && <span>|</span>}
                {profile.email && <span>{profile.email}</span>}

              </div>

              <ul className="profile-details-box">
                <li className="d-flex align-items-center justify-content-between py-3 border-bottom-1">
                  <div className="right-part">
                    <Link
                      to="#"
                      className="d-block"
                      onClick={handleEditProfileClick}
                    >
                      Edit Profile
                    </Link>
                    <span>Change or update profile details</span>
                  </div>
                  <div className="left-part">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="9" cy="9" r="2" stroke="#BEBEBE" />
                      <path
                        d="M13 15C13 16.1046 13 17 9 17C5 17 5 16.1046 5 15C5 13.8954 6.79086 13 9 13C11.2091 13 13 13.8954 13 15Z"
                        stroke="#BEBEBE"
                      />
                      <path
                        d="M2 12C2 8.22876 2 6.34315 3.17157 5.17157C4.34315 4 6.22876 4 10 4H14C17.7712 4 19.6569 4 20.8284 5.17157C22 6.34315 22 8.22876 22 12C22 15.7712 22 17.6569 20.8284 18.8284C19.6569 20 17.7712 20 14 20H10C6.22876 20 4.34315 20 3.17157 18.8284C2 17.6569 2 15.7712 2 12Z"
                        stroke="#BEBEBE"
                      />
                      <path
                        d="M19 12H15"
                        stroke="#BEBEBE"
                        stroke-linecap="round"
                      />
                      <path
                        d="M19 9H14"
                        stroke="#BEBEBE"
                        stroke-linecap="round"
                      />
                      <path
                        d="M19 15H16"
                        stroke="#BEBEBE"
                        stroke-linecap="round"
                      />
                    </svg>
                  </div>
                </li>

                <li className="d-flex align-items-center justify-content-between py-3 border-bottom-1">
                  <div className="right-part">
                    <Link
                      to="#"
                      className="d-block"
                      onClick={handleChangePassClick}
                    >
                      Change Password
                    </Link>
                    <span>Change the current password</span>
                  </div>
                  <div className="left-part">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M15.6809 5.34814C14.0521 5.34814 12.7265 6.66395 12.7265 8.29353C12.7265 9.92311 14.0521 11.2389 15.6809 11.2389C17.3097 11.2389 18.6353 9.92311 18.6353 8.29353C18.6353 6.66395 17.3097 5.34814 15.6809 5.34814ZM14.2465 8.29353C14.2465 7.49816 14.8748 6.84814 15.6809 6.84814C16.487 6.84814 17.1353 7.49816 17.1353 8.29353C17.1353 9.0889 16.487 9.73891 15.6809 9.73891C14.8748 9.73891 14.2465 9.0889 14.2465 8.29353Z"
                        fill="#BEBEBE"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M9.52998 20.8783C9.86298 20.414 9.97017 19.9429 9.96222 19.5233C10.3544 19.6387 10.7424 19.6533 11.1141 19.5828C11.8825 19.437 12.4511 18.9512 12.7527 18.5507L12.758 18.5437L12.7631 18.5366C13.2883 17.8043 13.2872 17.0543 13.1586 16.5164C13.0956 16.2528 13.0021 16.0361 12.9245 15.8846C12.8853 15.8081 12.849 15.746 12.8207 15.7005C12.8132 15.6885 12.8063 15.6775 12.7999 15.6677C12.7112 15.5021 12.6111 15.3719 12.5269 15.2737L12.5359 15.2647L13.0001 14.8024C13.3817 14.9849 13.7957 15.0999 14.1583 15.1749C14.744 15.2962 15.3171 15.3369 15.6807 15.3369C19.582 15.3369 22.75 12.1863 22.75 8.29344C22.75 4.40056 19.582 1.25 15.6807 1.25C11.7794 1.25 8.61144 4.40056 8.61144 8.29344C8.61144 9.2105 8.82018 9.99588 9.02588 10.549C9.07825 10.6898 9.44293 10.3956 8.61144 8.29344C10.1114 5.23477 12.602 2.75 15.6807 2.75C18.7594 2.75 21.25 5.23477 21.25 8.29344C21.25 11.3521 18.7594 13.8369 15.6807 13.8369C15.4075 13.8369 14.9372 13.8044 14.4623 13.7061C13.9654 13.6032 13.5752 13.4504 13.3674 13.2779C13.0699 13.031 12.6332 13.0508 12.3592 13.3237L11.4774 14.2019C11.2757 14.4028 11.0818 14.6305 10.9794 14.8933C10.8499 15.2261 10.8912 15.5463 11.0394 15.8121C11.1273 15.9697 11.2689 16.1202 11.3278 16.183L11.3476 16.2042C11.4173 16.2811 11.4555 16.3314 11.4834 16.387L11.5098 16.4397L11.54 16.4817L11.5468 16.4924C11.5558 16.507 11.5712 16.533 11.5895 16.5685C11.6267 16.6412 11.6709 16.7445 11.6997 16.8652C11.7544 17.0937 11.7538 17.3656 11.5494 17.6551C11.4087 17.8384 11.1424 18.0506 10.8345 18.1091C10.5769 18.1579 10.1571 18.1261 9.59673 17.5681C9.30409 17.2766 8.83089 17.2766 8.53825 17.5681L8.24433 17.8608C7.96748 18.1365 7.94891 18.5782 8.20054 18.8761C8.20194 18.8778 8.2058 18.8826 8.2116 18.8903C8.22363 18.9062 8.24339 18.9336 8.2668 18.9704C8.31483 19.0461 8.37128 19.1508 8.41138 19.2706C8.48694 19.4963 8.49882 19.7374 8.31639 19.9966C8.19643 20.1519 7.95303 20.3287 7.67726 20.3815C7.4429 20.4264 7.14284 20.3931 6.8045 20.0562C6.51186 19.7647 6.03866 19.7647 5.74602 20.0562L4.7173 21.0807C4.55241 21.2449 4.4068 21.2643 4.26505 21.2434C4.09729 21.2186 3.93333 21.1293 3.84077 21.0562L2.9836 20.2025C2.74543 19.9653 2.73591 19.7821 2.75733 19.6511C2.78643 19.4731 2.89711 19.3025 2.9836 19.2163L10.6279 11.6033C10.8747 11.3575 10.9185 10.9735 10.7333 10.6784L10.7311 10.6748C10.7284 10.6703 10.7232 10.6615 10.7158 10.6487C10.7012 10.6231 10.6781 10.5814 10.6494 10.5251C10.5918 10.4123 10.5122 10.2423 10.4318 10.0262C10.2701 9.59135 10.1114 8.98632 10.1114 8.29344ZM8.20054 18.8761C8.20192 18.8777 8.2033 18.8793 8.20469 18.881L8.20354 18.8796L8.20054 18.8761Z"
                        fill="#BEBEBE"
                      />
                    </svg>
                  </div>
                </li>
                <li className="d-flex align-items-center justify-content-between py-3 border-bottom-1">
                  <div className="right-part">
                    <Link
                      href=""
                      className="d-block"
                      style={{ cursor: "default", pointerEvents: "none" }}
                    >
                      Visit Website
                    </Link>
                    <a
                      href="https://www.ez1020.com/"
                      className="d-block blue-text"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      https://www.ez1020.com/
                    </a>
                  </div>
                  <div className="left-part">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6 18L18 6M18 6H9M18 6V15"
                        stroke="#BEBEBE"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                </li>

                <li className="d-flex align-items-center justify-content-between py-3">
                  <div className="right-part">
                    <button
                      type="button"
                      onClick={handleLogout}
                      className="d-block"
                      style={{
                        color: "#FF3A44",
                        background: "none",
                        border: "none",
                        padding: 0,
                        font: "inherit",
                        cursor: "pointer",
                        textAlign: "left",
                      }}
                    >
                      Log Out
                    </button>
                  </div>
                  <div className="left-part">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 0C10.4734 0 10.8571 0.383756 10.8571 0.857143C10.8571 1.33053 10.4734 1.71429 10 1.71429C5.42393 1.71429 1.71429 5.42393 1.71429 10C1.71429 14.5761 5.42393 18.2857 10 18.2857C10.4734 18.2857 10.8571 18.6695 10.8571 19.1429C10.8571 19.6162 10.4734 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0Z"
                        fill="#FF3A44"
                      />
                      <path
                        d="M15.1082 7.17752C14.7735 6.84279 14.7735 6.30007 15.1082 5.96534C15.4429 5.6306 15.9856 5.6306 16.3204 5.96534L19.749 9.39391C20.0837 9.72864 20.0837 10.2714 19.749 10.6061L16.3204 14.0347C15.9856 14.3694 15.4429 14.3694 15.1082 14.0347C14.7735 13.6999 14.7735 13.1572 15.1082 12.8225L17.0735 10.8571H7.71429C7.2409 10.8571 6.85714 10.4734 6.85714 10C6.85714 9.52661 7.2409 9.14286 7.71429 9.14286H17.0735L15.1082 7.17752Z"
                        fill="#FF3A44"
                      />
                      <path
                        d="M10 0C10.4734 0 10.8571 0.383756 10.8571 0.857143C10.8571 1.33053 10.4734 1.71429 10 1.71429C5.42393 1.71429 1.71429 5.42393 1.71429 10C1.71429 14.5761 5.42393 18.2857 10 18.2857C10.4734 18.2857 10.8571 18.6695 10.8571 19.1429C10.8571 19.6162 10.4734 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0Z"
                        stroke="#FF3A44"
                      />
                      <path
                        d="M15.1082 7.17752C14.7735 6.84279 14.7735 6.30007 15.1082 5.96534C15.4429 5.6306 15.9856 5.6306 16.3204 5.96534L19.749 9.39391C20.0837 9.72864 20.0837 10.2714 19.749 10.6061L16.3204 14.0347C15.9856 14.3694 15.4429 14.3694 15.1082 14.0347C14.7735 13.6999 14.7735 13.1572 15.1082 12.8225L17.0735 10.8571H7.71429C7.2409 10.8571 6.85714 10.4734 6.85714 10C6.85714 9.52661 7.2409 9.14286 7.71429 9.14286H17.0735L15.1082 7.17752Z"
                        stroke="#FF3A44"
                      />
                    </svg>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <ChangePasswordModal showChangePass={showChangePass} onClose={handleCloseChangePass} />
      <EditProfileModal
        showEditProfile={showEditProfile}
        onClose={handleCloseEditProfile}
      />
    </>
  );
};

export default MyProfileModal;